import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';
import {reducer as flashReducer} from 'redux-flash';
import {i18nReducer} from 'react-redux-i18n';
import user from './user';
import layout from './layout';
import language from './language';
import formData from './formData';
import leaderBoard from './leaderBoard';


const reducers = combineReducers({
    user: user,
    layout: layout,
    language: language,
    form: formReducer,
    flash: flashReducer,
    routing: routerReducer,
    i18n: i18nReducer,
    formData: formData,
    leaderBoard:leaderBoard
});

export default reducers;




// WEBPACK FOOTER //
// ./src/store/reducers/index.js